import { Injectable } from '@angular/core';
import * as speechSdk from 'microsoft-cognitiveservices-speech-sdk';
import { SpeechToTextService } from '@privatelibdev/speech-to-text';

// The Azure lib always builds a recognizer on the default mic and does not
// expose stream input. Rebuild the public recognizer onto a MediaStream so
// telehealth (mixed screen+mic) and a selected microphone work with Azure.
@Injectable({
  providedIn: 'root',
})
export class AzureSpeechInputService {
  constructor(private readonly speech: SpeechToTextService) {}

  attachStream(stream: MediaStream | null): void {
    this.closeRecognizer();

    const hasAudio = !!stream?.getAudioTracks().length;
    const audioConfig = hasAudio
      ? speechSdk.AudioConfig.fromStreamInput(stream)
      : speechSdk.AudioConfig.fromDefaultMicrophoneInput();

    this.speech.audioConfig = audioConfig;
    this.speech.speechRecognizer = new speechSdk.SpeechRecognizer(
      this.speech.speechConfig,
      audioConfig,
    );
    this.bindEvents();
  }

  resetToDefaultMic(): void {
    this.attachStream(null);
  }

  private closeRecognizer(): void {
    try {
      this.speech.speechRecognizer?.close();
    } catch {
      // already closed
    }
  }

  private bindEvents(): void {
    const recognizer = this.speech.speechRecognizer;
    recognizer.recognizing = (_s, event) => {
      this.speech.recognizing.next(event.result.text);
    };
    recognizer.recognized = (_s, event) => {
      if (
        event.result.reason === speechSdk.ResultReason.RecognizedSpeech &&
        event.result.text
      ) {
        let recognizedText = event.result.text;
        if (this.speech.removeLastFullStop) {
          recognizedText = recognizedText.replace(/\.$/, '');
        }
        this.speech.recognizer.next(recognizedText);
      }
    };
  }
}
